<template>
  <WdsModal :show="show" :title="$t('Remove job from current project')" @cancel="close">
    <div>
      <WdsText>
        {{
          $t(
            'You\'re about to remove the job ":job" from the project ":project". This means that spend on the job\'s budget will not count towards this project\'s budget spend anymore. Do you want to proceed?',
            { project: project.name, job: job.name },
          )
        }}
      </WdsText>
    </div>
    <WdsStack class="tw-mt-5" justify-space-between>
      <WdsButton tertiary @click="close">{{ $t('Cancel') }}</WdsButton>
      <WdsStack gap-sm align-center>
        <WdsSpinner v-if="loading" indeterminate />
        <WdsButton primary :disabled="loading" @click="submit">{{ $t('Confirm') }}</WdsButton>
      </WdsStack>
    </WdsStack>
  </WdsModal>
</template>

<script lang="ts" setup>
import { WdsButton, WdsText, WdsSpinner, WdsStack, WdsModal } from '@worksome/wds-components'
import gql from 'graphql-tag'
import { ref } from 'vue'
import { publicApi } from '@/app-bootstrapping/SetUpApollo'
import { NetworkError } from '@/utils/notification'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const props = defineProps({
  project: {
    required: true,
    type: Object,
  },
  job: {
    required: true,
    type: Object,
  },
})

const emit = defineEmits(['close', 'removed'])

const show = ref(true)
const loading = ref(false)

function close() {
  show.value = false
  setTimeout(() => emit('close'), 150)
}

async function submit() {
  // Submitting
  loading.value = true
  try {
    await publicApi.mutate({
      mutation: gql`
        mutation DetachJobFromProject($input: DetachJobFromProjectInput!) {
          detachJobFromProject(input: $input) {
            id
          }
        }
      `,
      variables: {
        input: {
          project: props.project.id,
          job: props.job.id,
        },
      },
    })
    loading.value = false
    emit('removed')
    close()
  } catch (ex: any) {
    new NetworkError({
      msg: $t('Error occurred. The action was not completed'),
      ex,
    }).dispatch()
    loading.value = false
  }
}
</script>
